import { render } from "./ArticleTeaser.vue?vue&type=template&id=d67693ee&ts=true"
import script from "./ArticleTeaser.vue?vue&type=script&lang=ts"
export * from "./ArticleTeaser.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__